import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=981a557e&scoped=true&lang=pug"
import script from "./Listado.vue?vue&type=script&lang=js"
export * from "./Listado.vue?vue&type=script&lang=js"
import style0 from "./Listado.vue?vue&type=style&index=0&id=981a557e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981a557e",
  null
  
)

export default component.exports